export default __webpack_public_path__ + "static/joko-app-screenshot-home-3-fr-1bd1a47cb54494e5cf8d6dbd0dde2554.png";